/**
 * Resolve the token for KA /production/bootstrap — URL, saved hub link, TS session, or portion_urls.
 */
import { readStaffPortalTokenFromStoredStart } from "@/lib/staffPortal";
import { hasTsSession, loadTsPortionUrls, loadTsToken } from "@/lib/tsIdentity";

function tokenFromUrlString(url) {
  if (!url) return "";
  try {
    const u = new URL(url, window.location.origin);
    const fromQuery = (u.searchParams.get("token") || "").trim();
    if (fromQuery) return fromQuery;
    const hash = u.hash || "";
    if (hash.startsWith("#t=")) return decodeURIComponent(hash.slice(3).trim());
  } catch {
    /* ignore */
  }
  return "";
}

/** Bootstrap token for ProductionHub — supports legacy links and TS app shell (/ts/app/kitchen). */
export function readKitchenHubBootstrapToken() {
  const q = new URLSearchParams(window.location.search);
  const fromQuery = (q.get("token") || "").trim();
  if (fromQuery) return fromQuery;

  const h = window.location.hash || "";
  if (h.startsWith("#t=")) return decodeURIComponent(h.slice(3).trim());

  const fromStored = readStaffPortalTokenFromStoredStart("kitchen");
  if (fromStored) return fromStored;

  const fromPortion = tokenFromUrlString(loadTsPortionUrls()?.kitchen);
  if (fromPortion) return fromPortion;

  if (hasTsSession()) {
    const tb = loadTsToken();
    if (tb) return tb;
  }

  return "";
}
